<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
                label="Avaliação"
                v-model="form.filters.avaliacao"
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
                v-model="form.filters.tipoAvaliacao"
                :items="form.lists.listTipoAvaliacao"
                item-text="descricao"
                item-value="tipoAvaliacaoId"
                label="Tipo de Avaliação"
                outlined
                dense
            ></v-select>
          </v-col>
          <sigfoco-select-ativo
              :cols="3"
              v-model="form.filters.situacao"
              labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
                :text="'Buscar'"
                :icon="'mdi-magnify'"
                @click="buscarAvaliacoes()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
                :text="'Limpar'"
                :icon="'mdi-eraser'"
                @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
                :text="'Incluir'"
                :icon="'mdi-plus'"
                @click="openDialogManterAvaliacaoFormacao()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
          class="mt-5"
          :headers="headers"
          :items="form.lists.listAvaliacaoFormacao"
          :items-per-page="10"
          :footer-props="$footerProps"
      >
        <template v-slot:[`item.situacao`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
              :text="'Visualizar'"
              :icon="'mdi-eye-outline'"
              :small="true"
              @click="openDialogVisualizarAvaliacaoFormacao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
              :text="'Editar'"
              :icon="'mdi-pencil'"
              :small="true"
              @click="openDialogManterAvaliacaoFormacao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
              :text="'Excluir'"
              :icon="'mdi-delete'"
              :small="true"
              @click="excluirAvaliacaoFormacao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
              :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
              :icon="`${item.situacao ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
              :color="`${item.situacao ? 'var(--primary-button-color)' : 'silver'}`"
              :small="true"
              @click="inativarAtivarAvaliacaoFormacao(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarPeriodoFormacaoDialog
        :visible="dialogManterAvaliacaoFormacao.visible"
        :content="dialogManterAvaliacaoFormacao.content"
        :edit="dialogManterAvaliacaoFormacao.edit"
        @onClose="dialogManterAvaliacaoFormacao.close()"
        @onSave="buscarAvaliacoes()"
    ></CadastrarEditarPeriodoFormacaoDialog>
    <VisualizarAvaliacaoFormacaoDialog
        :visible="dialogVisualizarAvaliacaoFormacao.visible"
        :content="dialogVisualizarAvaliacaoFormacao.content"
        @onClose="dialogVisualizarAvaliacaoFormacao.close()"
    ></VisualizarAvaliacaoFormacaoDialog>
  </div>
</template>

<script>
import { Dialog} from "~/commons/classes/dialog";
import { AvaliacaoFormacao } from "~/commons/classes/avaliacao-formacao";
import ManterAvaliacaoFormacaoService from '~/services/manter-avaliacao-formacao';
import AuthService from '~/services/auth.service';
import CadastrarEditarPeriodoFormacaoDialog from "./dialogs/CadastrarEditarAvaliacaoFormacaoDialog.vue";
import VisualizarAvaliacaoFormacaoDialog from "./dialogs/VisualizarAvaliacaoFormacaoDialog.vue";


export default {
  name: "ManterAvaliacaoFormacaoView",
  mixins: [ManterAvaliacaoFormacaoService, AuthService],
  components: {
    CadastrarEditarPeriodoFormacaoDialog,
    VisualizarAvaliacaoFormacaoDialog
  },
  data: () => ({
    dialogManterAvaliacaoFormacao: Dialog.Build(),
    dialogVisualizarAvaliacaoFormacao: Dialog.Build(),

    form: {
      filters: {
        avaliacao: null,
        tipoAvaliacao: null,
        situacao: null,
      },
      lists: {
        listAvaliacaoFormacao: [],
        listTipoAvaliacao: [],
        listTiposResposta: [],
        listObrigatoriedade: [
          { descricao: "Obrigatória", obrigatoriedade: true },
          { descricao: "Não Obrigatória", obrigatoriedade: false },
        ]
      }
    },
    headers: [
      { text: "Avaliação", align: "center", value: "avaliacao" },
      { text: "Tipo de Avaliação", align: "center", value: "tipoAvaliacao" },
      { text: "Situação", align: "center", value: "situacao" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ]
  }),
  methods: {
    openDialogManterAvaliacaoFormacao(avaliacaoFormacao) {
      if (avaliacaoFormacao) {
        this.$visualizarAvaliacaoFormacao(avaliacaoFormacao).then(
            ({ data }) => {
              const editarAvaliacao = data.lista;
              editarAvaliacao.listTipoAvaliacao = this.form.lists.listTipoAvaliacao;
              editarAvaliacao.listTiposResposta = this.form.lists.listTiposResposta;
              editarAvaliacao.listObrigatoriedade = this.form.lists.listObrigatoriedade;
              this.dialogManterAvaliacaoFormacao.open(editarAvaliacao, true);
            });
      } else {
        const novaAvaliacao = AvaliacaoFormacao.Build();
        novaAvaliacao.listTipoAvaliacao = this.form.lists.listTipoAvaliacao;
        novaAvaliacao.listTiposResposta = this.form.lists.listTiposResposta;
        novaAvaliacao.listObrigatoriedade = this.form.lists.listObrigatoriedade;
        this.dialogManterAvaliacaoFormacao.open(novaAvaliacao);
      }
    },
    openDialogVisualizarAvaliacaoFormacao(avaliacaoFormacao) {
      this.$visualizarAvaliacaoFormacao(avaliacaoFormacao).then(
          ({ data }) => {
            this.dialogVisualizarAvaliacaoFormacao.open(data.lista);
          });
    },
    buscarAvaliacoes() {
      this.$buscarAvaliacaoFormacao({ params: this.form.filters }).then(({ data }) => {
        this.form.lists.listAvaliacaoFormacao = data.itens;
      }).catch((error) => {
        console.error("Erro ao buscar períodos:", error);
      });
    },
    inativarAtivarAvaliacaoFormacao(avaliacaoFormacao) {
      this.$swal({
        text: `Deseja ${avaliacaoFormacao.situacao ? "inativar" : "ativar"} a Avaliação?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarAvaliacaoFormacao(avaliacaoFormacao.id).then(({ data }) => {
          this.$notifySuccess(`${data.mensagem}`);
          this.buscarAvaliacoes();
        });
      });
    },
    excluirAvaliacaoFormacao(avaliacaoFormacao) {
      this.$swal({
        text: `Deseja confirmar a exclusão da Avaliação?`,
        type: "error",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$excluirAvaliacaoFormacao(avaliacaoFormacao.id).then(({ data }) => {
          this.$notifySuccess(`${data.mensagem}`);
          this.buscarAvaliacoes();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.form.lists.listAvaliacaoFormacao = [];
      this.form.filters.avaliacao = null;
      this.form.filters.tipoAvaliacao = null;
      this.form.filters.situacao = null;

      this.$nextTick(() => {
        this.$set(this.form.filters, 'situacao', null);
      });
    },
    buscarTiposAvaliacaoFormacao() {
      this.$buscarTiposAvaliacaoFormacao().then(({ data }) => {
        this.form.lists.listTipoAvaliacao = data.lista;
      }).catch((error) => {
        console.error("Erro ao buscar avaliações:", error);
      });
    },
    buscarTiposRespostaAvaliacaoFormacao() {
      this.$buscarTiposRespostaAvaliacaoFormacao().then(({ data }) => {
        this.form.lists.listTiposResposta = data.lista;
      }).catch((error) => {
        console.error("Erro ao buscar avaliações:", error);
      });
    }
  },
  mounted() {
    this.buscarTiposRespostaAvaliacaoFormacao();
    this.buscarTiposAvaliacaoFormacao();
  }
};
</script>